import { useEffect, useState } from 'react';
import ChatwootService, {
  type ChatwootState,
} from '../services/ChatwootService';

const useChatwootSnapshot = (): ChatwootState => {
  const [snapshot, setSnapshot] = useState<ChatwootState>(
    ChatwootService.getSnapshot(),
  );

  useEffect(() => ChatwootService.subscribe(setSnapshot), []);

  return snapshot;
};

export default useChatwootSnapshot;
